exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shapeHome[data-v-4e26af64]{position:relative;display:inline-block}.angle[data-v-4e26af64]{display:block;width:0;height:0;border-width:0 1.5rem 1.5rem;border-style:solid;border-color:transparent transparent #fc0;transform:rotate(315deg)}.red[data-v-4e26af64]{border-color:transparent transparent #de0112}.qye[data-v-4e26af64]{border-color:transparent transparent #ffa304}.sye[data-v-4e26af64]{border-color:transparent transparent #ffe301}.angletext[data-v-4e26af64]{transform:rotate(315deg);display:inline-block;color:#fff;position:absolute;top:.3rem;left:1.3rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e26af64","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shape.vue
// module id = 13
// module chunks = 0